enum TransportLocationQuantityUnit {
	TON = 'ton',
	CUBIC = 'cubic',
	PIECE = 'per_piece'
}

export default TransportLocationQuantityUnit
